import React, { useEffect } from 'react';
import './NotFoundPage.css';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'ÜNMAK | Sayfa bulunamadı';
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-bg" aria-hidden="true" />
      <div className="not-found-card">
        <div className="not-found-logo">
          <img src="/assets/img/logo.png" alt="Ünmak" />
        </div>
        <div className="not-found-code" aria-hidden="true">404</div>
        <h1 className="not-found-title">Sayfa bulunamadı</h1>
        <p className="not-found-text">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
      </div>
    </div>
  );
}
